import { CssBaseline } from "@mui/material";
import type { ThemeOptions } from "@mui/material/styles";
import { StyledEngineProvider, ThemeProvider, createTheme } from "@mui/material/styles";
import type { ReactNode } from "react";
import React, { useMemo } from "react";

import GlobalStyles from "./GlobalStyles";
import breakpoints from "./breakpoints";
import componentsOverride from "./overrides";
import palette from "./palette";
import shadows, { customShadows } from "./shadows";
import typography from "./typography";

type ThemeConfigProps = { children: ReactNode };

export default function ThemeConfig({ children }: ThemeConfigProps): JSX.Element {
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: { ...palette.light, mode: "light" },
      typography,
      shape: { borderRadius: 8 },
      direction: "ltr",
      shadows: shadows.light,
      customShadows: customShadows.light,
      breakpoints,
    }),
    [],
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />

        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
